<template>
    <v-dialog v-model="dialog" width="800">
        <v-card>
            <v-card-title primary-title>
                <h4>
                    Agregar imagenes
                </h4>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <FileDropzone :files="archivo" :tipos="tipos_validos" :multiple="tipo != 'mini'" :max_size="100" />
                <div class="d-flex justify-end" style="margin-top: 10px;">
                    <v-btn color="success" :loading="load" @click="guardarImagenes()">
                        <v-icon left>fas fa-save</v-icon>
                        Guardar
                    </v-btn>
                </div>
            </v-card-text>

        </v-card>
    </v-dialog>
</template>

<script>
import FileDropzone from '../../util/FileDropzone.vue';

export default {
    data() {
        return {
            archivo: [],
            tipos_validos: ['.jpeg', '.jpg', '.webp', '.png'],
            load: false,
        };
    },
    methods: {
        async guardarImagenes() {
            console.log("imagenes guardadas");
            if (this.tipo === 'grandes') {
                // envio a imagenes grandes
            } else if (this.tipo === 'mini') {
                // envio a imagenes chicas
            }
        }
    },
    props: {
        value: Boolean,
        vehiculo_id: {
            type: String,
            default: ''
        },
        tipo: {
            type: String,
            default: ''
        }
    },
    computed: {
        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    components: {
        FileDropzone
    },
};
</script>
